/*
 * @Author: zl
 * @Date: 2022-12-14 08:59:42
 * @LastEditTime: 2022-12-15 10:29:08
 * @LastEditors: zl
 * @Description: 数据角色权限
 */
import request from '@/api/request'

/**
 * 获取数据角色列表
 * 作者：崔北超
 */
export const selectDataRole = function (data) {
    return request({
        url: '/sysDataRole/selectDataRole',
        method: 'post',
        data
    })
}

/**
 * 新增或者更新数据角色
 * 作者：崔北超
 */
export const saveOrUpdateDataRole = function (data) {
    return request({
        url: '/sysDataRole/saveOrUpdateDataRole',
        method: 'post',
        data
    })
}

/**
 * 获取角色下的配置项目建设单位
 * 作者：崔北超
 */
export const getConstructionUnitByRole = function (data) {
    return request({
        url: '/sysDataRole/getConstructionUnitByRole',
        method: 'post',
        data
    })
}

/**
 * 查询数据角色下的配置项目
 * 作者：崔北超
 */
export const getProjectListByRole = function (data) {
    return request({
        url: '/sysDataRole/getProjectListByRole',
        method: 'post',
        data
    })
}

/**
 * 查询用于配置的项目
 * 作者：崔北超
 */
export const getProjectList = function (data) {
    return request({
        url: '/sysDataRole/getProjectList',
        method: 'post',
        data
    })
}

/**
 * 保存直接配置的项目
 * 作者：崔北超
 */
export const saveDirectConfigData = function (data) {
    return request({
        url: '/sysDataRole/saveDirectConfigData',
        method: 'post',
        data
    })
}

/**
 * 删除数据角色
 * 作者：崔北超
 */
export const deleteDataRole = function (data) {
    return request({
        url: '/sysDataRole/deleteDataRole',
        method: 'post',
        data
    })
}

/**
 * 获取项目建设单位负责人
 * 作者：崔北超
 */
export const getProjectUser = function (data) {
    return request({
        url: '/sysDataRole/getProjectUser',
        method: 'post',
        data
    })
}

/**
 * 条件配置获取项目接口
 * 作者：崔北超
 */
export const getProjectByConfigCondit = function (data) {
    return request({
        url: '/sysDataRole/getProjectByConfigCondit',
        method: 'post',
        data
    })
}

/**
 * 保存生效的规则和规则
 * 作者：崔北超
 */
export const saveConfigCondit = function (data) {
    return request({
        url: '/sysDataRole/saveConfigCondit',
        method: 'post',
        data
    })
}

/**
 * 获取保存生效的规则
 * 作者：崔北超
 */
export const getConfigCondit = function (data) {
    return request({
        url: '/sysDataRole/getConfigCondit',
        method: 'post',
        data
    })
}